import { createContext } from "react";
import { useRef } from "react";
import localeText from "../../locale";
import { Toast } from "primereact/toast";
import { useContext } from "react";

export const ToastContext = createContext(null);

const ToastProvider = ({ children }) => {
  const toast = useRef(null);

  const state = {
    showSuccessToast: ({ detail }) => {
      const message = localeText(detail) || detail || "";
      toast.current.show({
        severity: "success",
        summary: localeText("success"),
        detail: message,
        life: 6000,
      });
    },
    showInfoToast: ({ summary, detail }) => {
      const message = detail ? localeText(detail) || detail : "";
      toast.current.show({
        severity: "info",
        summary: localeText(summary),
        detail: message,
        life: 6000,
      });
    },
    showErrorToast: ({ code = 500000, detail, message, fallbackMessage }) => {
      let msg;
      if (detail) {
        msg = localeText(detail) || detail;
      } else {
        const mapped = localeText("data")?.find((entry) => entry.code === code);
        if (mapped) {
          const baseMessage = mapped.message;
          msg = code === 500000 && message ? `${baseMessage}: ${message}` : baseMessage;
        } else if (message || fallbackMessage) {
          msg = message || fallbackMessage;
        } else {
          msg = `${localeText("errorOfSystem")} (Código: ${code})`;
        }
      }

      toast.current.show({
        severity: "error",
        summary: localeText("error"),
        detail: msg,
        life: 6000,
      });
    },
  };

  return (
    <ToastContext.Provider value={state}>
      <Toast ref={toast} baseZIndex={11000} style={{ zIndex: 11000 }} />
      {children}
    </ToastContext.Provider>
  );
};

export const useToastContext = () => {
  return useContext(ToastContext);
};

export default ToastProvider;
